// Radix Select forbids an empty string value, so "no warehouse" needs a sentinel.
export const ALL_WAREHOUSES = "__all__";
